<template>
<el-dialog :title="drawer.title" :visible.sync="drawer.visible" width="60%" :close-on-click-modal="false">
    <el-form :model="ruleForm" :rules="rules" ref="batchRuleForm" class="dialogRuleForm" :inline="true" label-position="top">
        <el-row>
            <el-col :span="8">
                <el-form-item label="品牌名称" prop="company_id" style="width: 100%;">
                    <el-select v-model="ruleForm.company_id" placeholder="品牌名称" filterable style="width: 100%;">
                        <el-option v-for="(item,index) in companyList" :key="index" :label="item.title" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="花费日期" prop="cost_date" style="width: 100%;">
                    <el-date-picker type="date" placeholder="选择日期" v-model="ruleForm.cost_date" style="width: 100%;"></el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="平台名称" prop="promoter_platform_id" style="width: 100%;">
                    <el-select v-model="ruleForm.promoter_platform_id" placeholder="平台名称" filterable style="width: 100%;" @change="changePlatform">
                        <el-option v-for="(item,index) in platformList" :key="index" :label="item.title" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>

        <div class="storeListBox">
            <el-form-item v-for="(item,index) in platformStoreList" :key="index" :label="item.store.title">
                <el-input v-model="cost['store_'+item.store.id]" clearable></el-input>
            </el-form-item>
        </div>
    </el-form>

    <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('batchRuleForm')">保存</el-button>
        <el-button @click="resetForm('batchRuleForm')">重置</el-button>
    </div>
</el-dialog>
</template>

<style lang="less">
.dialogRuleForm {
    padding: 0;

    [class*=el-col-] {
        padding: 0 4px;
    }

    .el-dialog__body {
        padding: 0 20px;
    }

    .storeListBox {
        max-height: 750px;
        overflow: auto;
    }
}
</style>

<script>
import '../css/common.css'

export default {
    props: {
        companyList: {
            type: Array
        },
        platformList: {
            type: Array
        },
        storeList: {
            type: Array
        }
    },
    data() {
        return {
            drawer: {
                title: '',
                visible: false
            },
            cost: {},
            platformStoreList: [],
            ruleForm: {
                id: 0,
                company_id: '',
                promoter_platform_id: '',
                promoter_store_id: '',
                cost_date: '',
            },
            rules: {
                company_id: [{
                    required: true,
                    message: '请选择品牌',
                    trigger: 'change'
                }, ],
                promoter_platform_id: [{
                    required: true,
                    message: '请选择平台',
                    trigger: 'change'
                }, ],
                cost_date: [{
                    required: true,
                    message: '请选择时间',
                    trigger: 'change'
                }, ],
            }
        };
    },
    created() {

    },
    methods: {
        showDialog(options) {
            let that = this;
            if (options == '') {
                this.drawer.title = '添加推广平台花费';
            } else {
                this.drawer.title = '编辑推广平台花费';
            }
            this.drawer.visible = true;
            if (options != '') {
                let url = '/api/promoter.cost/read';
                this.$post(url, options).then(function (response) {
                    if (response.code == '200') {
                        that.ruleForm = response.data.row;
                    } else {
                        this.$message(response.msg);
                    }
                });
            }
        },

        getPickerData() {
            let that = this;
            let url = '/api/promoter.cost/picker';
            this.$post(url).then(function (response) {
                if (response.code == '200') {
                    that.storeList = response.data.storeList;
                    that.platformList = response.data.platformList;
                    that.companyList = response.data.companyList;
                } else {
                    this.$message(response.msg);
                }
            });

        },
        changePlatform(e) {
            if (e == '') return false;
            this.getStoreList(e);
        },

        getStoreList(promoterPlatformId) {
            let that = this;
            let url = '/api/promoter.store/index';
            let query = {};
            query.promoter_platform_id = promoterPlatformId;
            this.$post(url, query).then(function (response) {
                if (response.code == '200') {
                    let platformStoreList = response.data.list;
                    that.platformStoreList = platformStoreList;
                    let cost = {};
                    platformStoreList.forEach((item, index) => {
                        let k = 'store_' + item.store.id;
                        cost[k] = 0;
                    });
                    that.cost = cost;
                } else {
                    this.$message(response.msg);
                }
            });

        },

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let that = this;
                    let url = '';
                    if (this.ruleForm.id == '') {
                        url = '/api/promoter.cost/batchAppend';
                    } else {
                        url = '/api/promoter.cost/save';
                    }

                    let data = this.ruleForm;
                    data.cost = this.cost;
                    this.$post(url, data).then(function (response) {
                        if (response.code == '200') {
                            that.drawer.visible = false;
                            that.resetForm(formName);
                            // that.$parent.doSearch();
                            that.$emit("getTableData");
                        } else {
                            that.$message(response.msg);
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        }
    }
}
</script>
